// extracted by mini-css-extract-plugin
export var cancelButton = "ProductSelect-module--cancelButton--mdoK+";
export var container = "ProductSelect-module--container--TyYzx";
export var content = "ProductSelect-module--content--6nb5F";
export var footer = "ProductSelect-module--footer--80+b1";
export var noProducts = "ProductSelect-module--noProducts--Fei8Q";
export var subHeader = "ProductSelect-module--subHeader--24jRG";